import React, { Component } from 'react';
import { Image, Row, Col, Container } from 'react-bootstrap';
import {
    Card, CardText, CardBody, CardLink
} from 'reactstrap';

import teamimg1 from './../../_assets/images/myteam1.jpg';
class About extends Component {
    render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h2 className="h4 mt-4 text-black text-uppercase">our Team</h2>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <Card >
                            <Image className="img img-responsive" src={teamimg1} alt="Card image cap" />
                            <CardBody>
                                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
                                <CardLink>Card Link</CardLink>
                                <CardLink>Another Link</CardLink>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card>
                            <Image className="img img-responsive" src={teamimg1} alt="Card image cap" />
                            <CardBody>
                                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
                                <CardLink>Card Link</CardLink>
                                <CardLink>Another Link</CardLink>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card>
                            <Image className="img img-responsive" src={teamimg1} alt="Card image cap" />
                            <CardBody>
                                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
                                <CardLink>Card Link</CardLink>
                                <CardLink>Another Link</CardLink>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card>
                            <Image className="img img-responsive" src={teamimg1} alt="Card image cap" />
                            <CardBody>
                                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
                                <CardLink>Card Link</CardLink>
                                <CardLink>Another Link</CardLink>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="tabPanelrow">
                    <Col md={6}>
                        <Image className="img img-responsive" src={teamimg1} alt="about1" />
                    </Col>
                    <Col md={6}>
                        <div className="tabpanels">
                            <h3>About us - You must Know</h3>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> We NVRE are a Bangalore based green energy promoters</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> Initiated with a goal to return something to our Environment</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> Excellent reviews from our obliged Customers</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> We provide high quality solar products with new technology involved to be energy independent</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i>Our vision is to be the obvious choice for solar solution with innovative execution and reliable service</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i>We expertise in energy auditing & advising the best solution for costumers expectation</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i>Our Products & Services are for Solar Power Plant On/Off Grid, Street Light, Fencing, Water Heater, Heat Pump,
Light Kits, Lanterns, Solar Home Systems, Agricultural Pumps</p>
                        </div>
                    </Col>
                </Row>
                <Row><br /></Row>
            </Container>
        )
    }
}

export default About;